<script>
export default {
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const { values } = this;

    return {
      name: values.name || '',
      search: values.search || '',
      isArchive: values.isArchive || false,
    };
  },
  methods: {
    emitChange () {
      const { name, search, isArchive } = this;

      this.$emit('change', { name, search, isArchive });
    },

    handleNameInput (value) {
      this.name = value;
      this.emitChange();
    },
    handleSearchInput (value) {
      this.search = value;
      this.emitChange();
    },
    handleIsArchiveChange (value) {
      this.isArchive = value;
      this.emitChange();
    },
  },
  render () {
    const { readonly, disabled } = this;

    return (
      <div>
        <div class="form-field">
          <div class="form-field__label">
            <label for="nameInput">
              Название
            </label>
          </div>
          <u-input
            id="nameInput"
            name="name"
            disabled={disabled}
            static={readonly}
            required
            fullwidth
            value={this.name}
            onInput={this.handleNameInput}
          />
        </div>
        <div class="form-field">
          <div class="form-field__label">
            <label for="searchInput">
              Синонимы
            </label>
          </div>
          <u-input
            id="searchInput"
            name="search"
            disabled={disabled}
            static={readonly}
            fullwidth
            value={this.search}
            onInput={this.handleSearchInput}
          />
        </div>
        <div class="form-field">
          <div class="form-field__label">
            <u-checkbox
              name="isArchive"
              value="isArchive"
              disabled={disabled}
              static={readonly}
              checked={this.isArchive}
              onChange={this.handleIsArchiveChange}
            >
              Архивный
            </u-checkbox>
          </div>
        </div>
      </div>
    );
  },
};
</script>
